import React from 'react'
import Container, { TitleBar, Content } from './styles'

const InternFrame = (props) => {
  const { children, title, icon, subtitle, color } = props
  return (
    <Container>
      <TitleBar style={{ color }}>
        {title}
        {icon} 
        {subtitle}
      </TitleBar>
      <Content>{children}</Content>
    </Container>
  )
}



export default InternFrame
